export const getMetaTitleDescription = (path: string, title: string, description: string) => {
  const pageNum = path.split("/").pop();
  const pageDescription = /\/\d+$/.test(path) ? `Page #${pageNum} - ${description}` : description;
  const pageTitle = /\/\d+$/.test(path) ? `Page #${pageNum} - ${title}` : title;

  return { pageTitle, pageDescription };
};
